export default "__VITE_ASSET__6zdWNZzz__"